module.exports = __webpack_public_path__ + "img/down.62fa593b.svg";